import React from "react";
import "swiper/css";
const useSwiperCss = () => {
  return;
};

export default useSwiperCss;
